/** Eine Zeitraum-Zeile der Tabellenkomposition — ab genug Breite. */
import { X } from 'lucide-react';
import {
  RangeAvailabilitySelect,
  RangeFromInput,
  RangeMaxStayInput,
  RangeMinStayInput,
  RangeRateInput,
  RangeToInput,
} from './multiRangeControls';
import { RangeRestrictionCheck, RESTRICTIONS } from './multiRangeRestrictions';
import type { MultiRangeRow as Row } from './multiRangeRowModel';

interface Props {
  row: Row;
  index: number;
  onChange: (patch: Partial<Row>) => void;
  onRemove: () => void;
  disabled: boolean;
}

export function MultiRangeRow({ row, index, onChange, onRemove, disabled }: Props) {
  const control = { row, index, onChange, disabled, compact: true };
  return (
    <tr className="border-line/40 border-b align-top last:border-b-0">
      <td className="py-2 pr-2">
        <RangeFromInput {...control} />
      </td>
      <td className="py-2 pr-2">
        <RangeToInput {...control} />
      </td>
      <td className="py-2 pr-2">
        <RangeRateInput {...control} />
      </td>
      <td className="py-2 pr-2">
        <RangeAvailabilitySelect {...control} />
      </td>
      <td className="py-2 pr-2">
        <RangeMinStayInput {...control} />
      </td>
      <td className="py-2 pr-2">
        <RangeMaxStayInput {...control} />
      </td>
      {RESTRICTIONS.map((field) => (
        <td key={field.key} className="py-2 pr-2">
          <RangeRestrictionCheck {...control} field={field} />
        </td>
      ))}
      <td className="w-12 py-2 text-center">
        <button
          type="button"
          onClick={onRemove}
          disabled={disabled}
          className="text-ink-soft hover:text-sealwax -my-2 inline-flex size-11 items-center justify-center rounded disabled:opacity-40"
          aria-label={`Zeitraum ${index + 1} entfernen`}
        >
          <X size={14} aria-hidden />
        </button>
      </td>
    </tr>
  );
}
